var map = {
	"./Card-YES.svg": "abaa",
	"./Card.svg": "a056",
	"./Home-YES.svg": "38ea",
	"./Home.svg": "a694",
	"./Me-YES.svg": "cd5f",
	"./Me.svg": "1b20",
	"./Toast-erro.svg": "316f",
	"./Toast-right.svg": "c84c",
	"./TopUp.svg": "fa73",
	"./Transfer.svg": "26be",
	"./Warning-face.svg": "b7ae",
	"./Withdraw.svg": "b2dc",
	"./about_icon.svg": "aa73",
	"./ais_icon.svg": "b02b",
	"./avatar.svg": "11af",
	"./bca.svg": "cef0",
	"./card-face-logo-dacheng.svg": "3615",
	"./card-face-logo-huishang.svg": "6eb8",
	"./card-icon.svg": "8785",
	"./chevron-left.svg": "a270",
	"./chevron-right.svg": "64b0",
	"./contact-number.svg": "5695",
	"./eye-close.svg": "36eb",
	"./eye-open.svg": "6a8f",
	"./faq.svg": "3c1c",
	"./field-face.svg": "2d16",
	"./huzhao.svg": "cd1d",
	"./icon-24-JCB.svg": "6543",
	"./icon-24-SCB.svg": "f55b",
	"./icon-24-VISA.svg": "6615",
	"./icon-24-master.svg": "bb33",
	"./icon_bank_BAAC.svg": "6984",
	"./icon_bank_BAC.svg": "fbe2",
	"./icon_bank_BAY.svg": "1bfe",
	"./icon_bank_BBL.svg": "d82f",
	"./icon_bank_BOC.svg": "dbb0",
	"./icon_bank_BOT.svg": "c913",
	"./icon_bank_CIMB.svg": "2715",
	"./icon_bank_CITIbank.svg": "3fc8",
	"./icon_bank_EXIM.svg": "3da9",
	"./icon_bank_FlashPAY.svg": "26ff",
	"./icon_bank_GHB.svg": "3288",
	"./icon_bank_GSB.svg": "abb1",
	"./icon_bank_HSBC.svg": "99da",
	"./icon_bank_ICBC.svg": "0220",
	"./icon_bank_KNB.svg": "c658",
	"./icon_bank_Kbank.svg": "6383",
	"./icon_bank_LHB.svg": "c725",
	"./icon_bank_SCT.svg": "c0db",
	"./icon_bank_TBANK.svg": "4f00",
	"./icon_bank_TISCO.svg": "32aa",
	"./icon_bank_TMB.svg": "f7d5",
	"./icon_bank_UOB.svg": "3553",
	"./icon_bank_ktb.svg": "d405",
	"./icon_k_bank_icon.svg": "164b",
	"./jiazhao.svg": "76db",
	"./mastercard.svg": "7fa7",
	"./me-card.svg": "ce6f",
	"./me-settings.svg": "1ed6",
	"./me-user.svg": "133d",
	"./shuaxin.svg": "8d60",
	"./success-face.svg": "975b",
	"./visa.svg": "6e0f",
	"./xieyi-icon.svg": "17a7",
	"./yinlian.svg": "af06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bd7";